import React, { useState } from 'react';
import { Loader2, CheckCircle2 } from 'lucide-react';
import { toast } from '../components/ui/sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const BetaSection = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      toast.error("Please enter your email");
      return;
    }

    setIsSubmitting(true);
    
    try {
      const response = await fetch(`${API_URL}/api/register-beta`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });
      
      const result = await response.json();
      
      if (response.ok && result.success) {
        setIsSuccess(true);
        toast.success("Welcome to the Beta! Check your email for further instructions");
        
        // Reset form after 3 seconds
        setTimeout(() => {
          setEmail('');
          setIsSuccess(false);
        }, 3000);
      } else {
        toast.error(result.message || "Registration Failed. Please try again later");
      }
    } catch (error) {
      toast.error("Registration Failed. Please try again later");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="beta" className="section-padding bg-page-bg">
      <div className="container-custom">
        <div className="beta-wrapper">
          <div className="beta-content-side">
            <h2 className="heading-2 mb-6">Join the Battle</h2>
            <p className="body-large mb-8">
              Be among the first to experience Fight for Erebus. Sign up for exclusive beta access.
            </p>
            <div className="beta-perks">
              <div className="perk-item">
                <div className="perk-icon">✓</div>
                <span className="body-small">Early access to all elements</span>
              </div>
              <div className="perk-item">
                <div className="perk-icon">✓</div>
                <span className="body-small">Exclusive beta rewards</span>
              </div>
              <div className="perk-item">
                <div className="perk-icon">✓</div>
                <span className="body-small">Shape the game's future</span>
              </div>
            </div>
          </div>

          <div className="beta-form-side">
            <form onSubmit={handleSubmit} className="beta-form">
              <div className="form-group">
                <label htmlFor="email" className="form-label">
                  Email Address
                </label>
                <input
                  type="email"
                  id="email"
                  data-testid="beta-email-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="form-input"
                  placeholder="your@email.com"
                  disabled={isSubmitting || isSuccess}
                  required
                />
              </div>

              <button 
                type="submit" 
                data-testid="beta-submit-btn"
                className="btn-primary w-full"
                disabled={isSubmitting || isSuccess}
              >
                {isSubmitting ? (
                  <>
                    <Loader2 className="animate-spin" size={20} />
                    <span>Registering...</span>
                  </>
                ) : isSuccess ? (
                  <>
                    <CheckCircle2 size={20} />
                    <span>Registered!</span>
                  </>
                ) : (
                  <span>Request Beta Access</span>
                )}
              </button>

              <p className="form-disclaimer">
                By signing up, you'll receive updates about Fight for Erebus beta testing
              </p>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BetaSection;
